var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainWrapper", attrs: { id: "top" } },
    [
      _c("head-nav", { attrs: { gray: _vm.gray, pos: "fixed" } }),
      _vm._v(" "),
      _c("div", { staticClass: "innerWrapper" }, [
        _c("h1", [_vm._v(_vm._s(_vm.datum.title))]),
        _vm._v(" "),
        _c("h2", [_vm._v("Posted " + _vm._s(_vm.datum.createTime))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "swiperCon" },
          [
            _c(
              "swiper",
              {
                ref: "swiperTop",
                staticClass: "gallery-top",
                attrs: { options: _vm.swiperOptionTop }
              },
              _vm._l(_vm.datum.imgLst, function(img, index) {
                return _c("swiper-slide", {
                  key: index,
                  style: { backgroundImage: "url(" + img + ")" }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "swiper",
              {
                ref: "swiperThumbs",
                staticClass: "gallery-thumbs",
                attrs: { options: _vm.swiperOptionThumbs }
              },
              _vm._l(_vm.datum.imgLst, function(img, index) {
                return _c("swiper-slide", {
                  key: index,
                  style: { backgroundImage: "url(" + img + ")" }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.attachment
          ? _c("div", { staticClass: "cccCon" }, [_vm._v("Attachment")])
          : _vm._e(),
        _vm._v(" "),
        _vm.attachment
          ? _c("div", { staticClass: "uploadBox" }, [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    download: _vm.attachmentName,
                    href: _vm.attachmentSrc
                  }
                },
                [_vm._v(_vm._s(_vm.attachmentName))]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "txtCon" }, [
          _c("p", {
            staticClass: "p",
            domProps: { innerHTML: _vm._s(_vm.datum.description) }
          })
        ])
      ]),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ba79bd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ba79bd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/inner.vue
// module id = null
// module chunks = 